import {paginationNumbers} from "../helpers/helperFunctions";

export default function Paginator({
                                    totalPages = 10,
                                    currentPage = 10,
                                    onClick,
                                    loading
                                  }) {

  const onPageClick = (page) => {
    if (page !== currentPage && page !== "..." && page > 0 && page <= totalPages && !loading) {
      onClick(page);
    }
  };

  return (
    <div className="flex justify-center space-x-1 text-rand-100 text-sm font-medium mt-2">
      <div onClick={() => onPageClick(currentPage - 1)}
           className={`flex items-center justify-center w-16 h-8 text-center rounded border ${loading ? 'cursor-not-allowed animate-pulse bg-gray-300' : currentPage === 1 ? 'cursor-not-allowed text-neutral-darker bg-gray-100' : 'hover:bg-gray-100 cursor-pointer'}`}>
        {'Prev'}
      </div>

      {paginationNumbers(currentPage, totalPages).map((i, index) =>
        <div key={`paginator-${i}-${index}`} onClick={() => onPageClick(i)}
             className={`flex items-center justify-center w-8 h-8 text-center rounded border ${i === currentPage ? `text-white cursor-default bg-secondary-500 ${loading ? 'animate-pulse':''}` : loading ? 'cursor-not-allowed animate-pulse bg-gray-300' : i === '...' ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-gray-100'}`}>{i}</div>)}

      <div onClick={() => onPageClick(currentPage + 1)}
           className={`flex items-center justify-center w-16 h-8 text-center rounded border ${loading ? 'cursor-not-allowed animate-pulse bg-gray-300' : currentPage >= totalPages ? 'cursor-not-allowed text-neutral-darker bg-gray-100' : 'hover:bg-gray-100 cursor-pointer'}`}>
        {'Next'}
      </div>

    </div>
  );
}

